import { ChangeEvent, forwardRef } from 'react';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { TextFieldProps } from '@material-ui/core';
import { WbSelect } from '../WbTextField';

export const EditEnvironmentField = forwardRef(
  (
    props: {
      onChange: (env: any) => void;
      environments?: string[];
      label?: string;
      value: string | string[];
    } & Omit<TextFieldProps, 'value' | 'onChange' | 'select'>,
    _ref,
  ) => {
    const {
      onChange,
      environments,
      value,
      children,
      label,
      ...textFieldProps
    } = props;

    const handleChange = (event: ChangeEvent<any>) => {
      onChange([event.target.value]);
    };

    return (
      <WbSelect
        {...textFieldProps}
        id="select-env-radio"
        label={label ?? 'Environment'}
        value={value}
        onChange={handleChange}
        disabled={!environments}
        options={environments || []}
        getOptionLabel={e => snakeCaseToTitleCase(e)}
      />
    );
  },
);
